/**
 * WalterGO Cart Umami-Tracker
 * Spec: analytics/tracking-spec.md §3.5 + §3.6
 *
 * EVENTS (alle ohne Cart-Wert / Item-Count / Produkt-Daten):
 *   cart.drawer.open               trigger: 'add' | 'icon' | 'unknown'
 *   cart.drawer.close              —
 *   cart.item.remove               —
 *   cart.item.quantity_change      direction: 'increase' | 'decrease'
 *   cart.checkout_click            —
 *   cart.continue_shopping         —
 *
 * Dockt an Dawn-Standardelemente:
 *   <cart-drawer>                  Class-Wechsel (active) via MutationObserver
 *   cart-remove-button             Item entfernen
 *   .quantity__button[name=plus|minus]  Quantity-Buttons
 *   button[name="checkout"]        Checkout (sowohl #checkout als auch #CartDrawer-Checkout)
 *   PUB_SUB_EVENTS.cartUpdate      Add-to-Cart detektiert via product-form
 *
 * DSGVO-arm: keine Produkt-Handles, keine Wert-Daten, keine Mengen-Zahlen.
 */
(function () {
  'use strict';

  // IIFE-Scope-Variablen (vom Observer und Listener gemeinsam genutzt)
  var lastAddAt = 0;
  var lastCartIconClickAt = 0;

  function track(name, data) {
    if (typeof window.wgTrack === 'function') {
      window.wgTrack(name, data);
    }
  }

  // Cart-Update-Subscription (Add-to-Cart via product-form)
  // WICHTIG: subscribe ist eine function declaration (window.subscribe ok), aber
  // PUB_SUB_EVENTS ist const → script-scoped, NICHT auf window. Direkter Zugriff
  // via typeof-Check (kein ReferenceError bei undefined).
  function subscribeCartUpdate() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(subscribeCartUpdate, 200);
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
      if (payload && payload.source === 'product-form') {
        lastAddAt = Date.now();
      }
    });
  }
  subscribeCartUpdate();

  function init() {
    // Cart-Icon-Klick (für trigger='icon' Detection beim Drawer-Open)
    document.addEventListener('click', function (e) {
      var t = e.target.closest(
        'a[href$="/cart"], a[href$="/cart/"], #cart-icon-bubble, ' +
        '.header__icon--cart, summary.header__icon--cart'
      );
      if (t) lastCartIconClickAt = Date.now();
    });

    // Drawer Open/Close via MutationObserver auf <cart-drawer class="active">
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var wasActive = drawer.classList.contains('active');
      var classObs = new MutationObserver(function () {
        var isActive = drawer.classList.contains('active');
        if (isActive && !wasActive) {
          var trigger = 'unknown';
          var now = Date.now();
          if (now - lastAddAt < 1500) trigger = 'add';
          else if (now - lastCartIconClickAt < 1500) trigger = 'icon';
          track('cart.drawer.open', { trigger: trigger });
        } else if (!isActive && wasActive) {
          track('cart.drawer.close');
        }
        wasActive = isActive;
      });
      classObs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    // Item Remove (Event-Delegation, deckt Cart-Page und Drawer ab)
    document.addEventListener('click', function (e) {
      if (e.target.closest('cart-remove-button, .cart-remove-button, .remove-btn')) {
        track('cart.item.remove');
      }
    });

    // Quantity Change (plus/minus)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.quantity__button, .quantity-btn');
      if (!btn) return;
      var name = btn.getAttribute('name') || '';
      var dir = null;
      if (name === 'plus' || btn.classList.contains('quantity-btn-plus')) dir = 'increase';
      else if (name === 'minus' || btn.classList.contains('quantity-btn-minus')) dir = 'decrease';
      if (dir) track('cart.item.quantity_change', { direction: dir });
    });

    // Checkout-Click (Cart-Page #checkout + Cart-Drawer #CartDrawer-Checkout
    // → beide haben name="checkout")
    document.addEventListener('click', function (e) {
      if (e.target.closest('button[name="checkout"]')) {
        track('cart.checkout_click');
      }
    });

    // Continue Shopping (Drawer-empty-CTA, Cart-Page-Link)
    document.addEventListener('click', function (e) {
      if (e.target.closest(
        '.continue-shopping, .shop-now-btn, .cart-drawer__empty-content a[href]'
      )) {
        track('cart.continue_shopping');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
